/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import fetchAPI from '../helper/axios';
import Load from './load';

const FooterSubM: React.FC = () => {
    const [footerData, setData] = useState<any>(null);
   
     const [loading, setLoading] = useState<boolean>(true);
       const [error, setError] = useState<string | null>(null);
   const [retry, setRetry] = useState(0); // for retry trigger

useEffect(() => {
    const loadData = async () => {
      try {

         setData(await fetchAPI('node/30'));

      } catch (err: any) {
        setError(err.message);
           // Retry after 3 seconds
        setTimeout(() => setRetry((prev) => prev + 1), 10000);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [retry]);

   if (loading) return    <Load />;
  // if (error) return <div>Error: {error}</div>;

  // Extract URL safely
  const footerDataurl = footerData?.field_link_url?.[0]?.uri?.replace('internal:', '')?.trim();

  const handleClick = () => {
    if (!footerDataurl) {
      console.warn('No valid URL found in footerData');
      return;
    } 
    // Open in same tab or new tab as per your need
   // window.open(footerDataurl,"_blank"); // new tab
    window.location.href = footerDataurl;
    // window.location.href = footerDataurl; // same tab
  };

 
 //console.log("footerData",footerDataurl);
  return (

     <>
       
        <div className="cta footer dark-background text-center">
            <label className="footer-h1-label" >{footerData?.field_description?.[0]?.value}</label>
            <h4> {footerData?.field_content?.[0]?.value?.replace(/<\/?p>/g, '')}</h4>
            <button type="button" onClick={handleClick} className="btn btn-md btn-light">{footerData?.field_link_url?.[0]?.title || 'Learn More'}</button>
       </div>
        
        
  </>
  );
};

export default FooterSubM